import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectRegion = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.region && validation.errors.region
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.region && validation.errors.region
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {
          level: 0,
        };

        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="region-field" className="form-label">
        Select Region
      </Label>
      <Select
        name="region"
        id="region"
        value={
          validation?.values?.region?.value ? validation?.values?.region : null
        }
        placeholder="Select region"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("region", value);
          validation.setFieldError("region", "");
          validation.setFieldValue("adminLevel1", null);
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getRegions({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  name: {
                    $containsi: inputValue,
                  },
                },
              ],
              level: 0,
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.name}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("region", true)}
        className={
          validation.touched.region && validation.errors.region
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.region?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectRegion;
